export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-17.18cdc9ac.png";